const vendorsMap: Record<string, string> = {
    1085: 'Squid',
    358: 'MGID',
    164: 'Outbrain',
    851: 'Strossle',
};
export default vendorsMap;
